import { FontSizes, FontWeights } from '@fluentui/react';
var actionButton = function (theme) {
    return {
        color: theme.palette.neutralPrimary,
        height: '24px',
        width: '24px',
        zIndex: '1',
        marginLeft: '24px',
        fontSize: FontSizes.size18,
        fontWeight: FontWeights.regular,
        selectors: {
            ':hover': {
                color: theme.palette.neutralPrimary
            },
            ':active, :focus': {
                color: theme.palette.neutralPrimary
            },
            '&.is-disabled': {
                background: 'transparent'
            }
        }
    };
};
export var getStyles = function (props) {
    var theme = props.theme, responsive = props.responsive, cardsPerSlide = props.cardsPerSlide, itemWidth = props.itemWidth;
    return {
        buttonContainer: {
            display: 'flex',
            flex: '1',
            justifyContent: 'flex-end'
        },
        leftButton: actionButton(theme),
        rightButton: actionButton(theme),
        header: {
            color: theme.palette.neutralPrimary,
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            marginTop: '0px',
            marginBottom: '0px',
            marginRight: '24px',
            paddingBottom: '1px',
            fontSize: FontSizes.size18,
            fontWeight: FontWeights.semibold,
            selectors: {
                '@media screen and (max-width: 479px)': {
                    flex: 1,
                    whiteSpace: 'normal',
                    overflow: 'auto'
                }
            }
        },
        headerContainer: {
            display: 'flex',
            flexWrap: 'wrap',
            lineHeight: '24px',
            alignItems: 'baseline',
            marginBottom: '24px',
            selectors: {
                '@media screen and (max-width: 479px)': {
                    display: 'block'
                }
            }
        },
        card: [
            {
                displayName: 'coher-CardItem',
                boxSizing: 'border-box',
                paddingLeft: '8px',
                paddingRight: '8px',
                width: "".concat(itemWidth, "px")
            },
            responsive && {
                width: "".concat(100 / cardsPerSlide, "%")
            }
        ],
        cardContainer: {
            display: 'flex',
            flexDirection: 'row'
        },
        slide: [
            {
                display: 'flex',
                flexDirection: 'row',
                flexGrow: 1,
                overflow: 'hidden',
                width: '100%'
            },
            responsive && {
                margin: '0 -8px'
            }
        ],
        slideContainer: {
            display: 'flex',
            flexDirection: 'row',
            overflow: 'hidden'
        },
        scroll: {
            flex: '1',
            display: 'flex',
            transition: 'transform 0.2s cubic-bezier(0.8,0,0.2,1) 0s'
        },
        scrollContainer: {
            overflow: 'hidden'
        },
        supplementContainer: {
            display: 'flex',
            flex: 1,
            flexDirection: 'row',
            alignItems: 'baseline',
            lineHeight: '24px',
            marginTop: '0px',
            selectors: {
                '@media screen and (max-width: 479px)': {
                    marginLeft: '0px',
                    marginTop: '8px'
                }
            }
        },
        viewAllLink: {
            display: 'flex',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: FontSizes.size14,
            fontWeight: FontWeights.regular
        }
    };
};
//# sourceMappingURL=FeedCarousel.styles.js.map